export default __webpack_public_path__ + "static/media/chatify.67aed85f.png";